import "./contact.css";
import { FaEnvelope, FaPhone, FaGlobe } from "react-icons/fa";
import { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";

export default function Contact() {

  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);

  // ================= HANDLE CHANGE =================
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🔥 validation
    if (!form.name || !form.email || !form.message) {
      alert("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);

      await addDoc(collection(db, "contacts"), {
        ...form,
        createdAt: serverTimestamp()
      });

      alert("✅ Message sent successfully!");

      // reset form
      setForm({
        name: "",
        email: "",
        subject: "",
        message: ""
      });

    } catch (err) {
      console.error(err);
      alert("❌ Failed to send message");
    }

    setLoading(false);
  };

  return (
    <section className="contact" id="contact">

      <div className="contact-container">

        {/* LEFT PANEL */}
        <div className="contact-left">
          <h3>Get in Touch</h3>
          <p>
            I am available for academic collaborations, research consultations,
            and guest lectures.
          </p>

          <div className="contact-info">
            <div className="info-item">
              <FaEnvelope />
              <span>kulkarni.martand@university.edu</span>
            </div>

            <div className="info-item">
              <FaPhone />
              <span>+91 XXXXX XXXXX</span>
            </div>

            <div className="info-item">
              <FaGlobe />
              <span>www.drkmdiakarrao.com</span>
            </div>
          </div>
        </div>

        {/* RIGHT FORM */}
        <div className="contact-right">

          <form onSubmit={handleSubmit}>

            <div className="form-row">
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={form.name}
                onChange={handleChange}
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={form.email}
                onChange={handleChange}
              />
            </div>

            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={form.subject}
              onChange={handleChange}
            />

            <textarea
              name="message"
              placeholder="Write your message here..."
              rows="5"
              value={form.message}
              onChange={handleChange}
            ></textarea>

            <button className="send-btn" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>

          </form>

        </div>

      </div>

    </section>
  );
}